import { render, staticRenderFns } from "./appSwitcher.vue?vue&type=template&id=889e34de&scoped=true&"
import script from "./appSwitcher.vue?vue&type=script&lang=js&"
export * from "./appSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./appSwitcher.vue?vue&type=style&index=0&id=889e34de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889e34de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889e34de')) {
      api.createRecord('889e34de', component.options)
    } else {
      api.reload('889e34de', component.options)
    }
    module.hot.accept("./appSwitcher.vue?vue&type=template&id=889e34de&scoped=true&", function () {
      api.rerender('889e34de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/appSwitcher/appSwitcher.vue"
export default component.exports